<div class="input">
  <label class="input-label" [for]="label">
    {{ label }}
  </label>

  <input
    *ngIf="!inputMask"
    type="text"
    class="input-edit"
    [id]="label"
    [placeholder]="placeholder"
    [required]="required"
    [ngModel]="value"
    [disabled]="disabled"
    (ngModelChange)="value = $event; onChange($event)"
    (keyup)="showFilter = true"
    (click)="showFilter = true"
    (blur)="changeShowFilterTimeout()"
  />

  <input
    *ngIf="inputMask"
    type="text"
    class="input-edit"
    [id]="label"
    [placeholder]="placeholder"
    [mask]="inputMask"
    [dropSpecialCharacters]="dropSpecial"
    [required]="required"
    [ngModel]="value"
    [disabled]="disabled"
    (ngModelChange)="value = $event; onChange($event)"
    (keyup)="showFilter = true"
    (click)="showFilter = true"
    (blur)="changeShowFilterTimeout()"
  />

  <ul *ngIf="showFilter" class="list-items">
    <li
      class="items"
      *ngFor="let item of searchList | appFilter : value"
      role="button"
      tabindex="0"
      (click)="selectItem(item); onChange(value)"
      (keydown.enter)="selectItem(item); onChange(value)"
      (keydown.space)="selectItem(item); onChange(value)"
    >
      {{ item }}
    </li>

    <li class="p-5 text-bold-700 text-size-12" *ngIf="searchList.length <= 0">
      Não há itens semelhantes
    </li>
  </ul>
</div>
